"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentMenu = exports.ContentMenuItem = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var ContentMenuItem = /** @class */ (function (_super) {
    __extends(ContentMenuItem, _super);
    function ContentMenuItem(data) {
        var _this = _super.call(this, data) || this;
        _this.index = data.index;
        _this.navId = data.nav_id;
        _this.langId = data.lang_id;
        _this.isHome = data.is_home;
        _this.isHidden = data.is_hidden;
        _this.title = data.title;
        _this.titleTag = data.title_tag;
        _this.alias = data.alias;
        _this.path = data.path;
        _this.description = data.description;
        _this.hasChildren = data.has_children;
        _this.children = data.children.map(function (c) {
            return new ContentMenuItem(c);
        });
        return _this;
    }
    return ContentMenuItem;
}(BaseEntity_1.BaseEntity));
exports.ContentMenuItem = ContentMenuItem;
;
var ContentMenu = /** @class */ (function () {
    function ContentMenu(data) {
        this.id = data.id;
        this.name = data.name;
        this.alias = data.alias;
        this.items = data.items.map(function (i) {
            return new ContentMenuItem(i);
        });
    }
    return ContentMenu;
}());
exports.ContentMenu = ContentMenu;
//# sourceMappingURL=ContentMenu.js.map